
webpack.register(
    'modules/audio-landing/audio-landing',
    function() {
        return import('modules/audio-landing/audio-landing');
    },
    true
);